<div class="modal-dialog">
  <div class="modal-content">
    TTT
      <div class="modal-header">
          <h4 class="modal-title" id="myCenterModalLabel">{{ 'LABELS.SWITCH_LANGUAGE' | translate}}</h4>
          <button type="button" class="btn fis-btn" data-bs-dismiss="modal" aria-label="Close" (click)="close()"><i class="mdi mdi-close"></i></button>
      </div>

      <div class="modal-body">
        <div class="language-switching-modal">
          <ion-list>
            <ion-radio-group>
            <ion-item *ngFor="let item of languages"  (click)="onLanguageSwitch(item?.ShortCode)" >
              <!-- <ion-thumbnail slot="start">
                <img [src]="item?.icon">
              </ion-thumbnail> -->
              <ion-label>{{item?.FullName}}</ion-label>
              <ion-radio slot="end" [checked]="currentLanguage === item?.ShortCode" [value]="item?.ShortCode"></ion-radio>
            </ion-item>
      
          </ion-radio-group>
          </ion-list>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="btn  fis-btn" (click)="close()" strong>{{ 'LABELS.CLOSE' | translate}}</button>
      </div>

  </div>
</div>
